<template>
    <PageView>
        <a-card title="列表">
            <a-button
                type="primary"
                slot="extra"
                @click="
                    () => {
                        form.resetFields()
                        isShowJf = true
                        id = ''
                    }
                "
                >新增
            </a-button>
            <a-table
                :loading="loading"
                :columns="columns"
                :dataSource="data"
                :pagination="{ total, pageSize, showSizeChanger, current }"
                @change="changePagination"
                bordered
                :scroll="{ x: true }"
            >
            </a-table>
        </a-card>
        <!--新增管理员-->
        <a-modal
            :title="id ? '修改' : '新增'"
            :visible="isShowJf"
            @ok="addAdmin"
            :confirmLoading="confirmLoading"
            centered
            :closable="false"
            @cancel="isShowJf = false"
            :maskClosable="false"
            width="800px"
        >
            <a-form :form="form" style="margin-top: 20px">
                <a-form-item label="内容">
                    <a-input
                        type="text"
                        v-decorator="['name', { rules: [{ required: true, message: '请输入内容' }] }]"
                        placeholder="请输入内容"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
    </PageView>
</template>

<script type="text/jsx">
import Order from '../../api/Order.js'
export default {
    name: 'admin',
    data () {
        return {
            loading: true,
            columns: [
                {
                    title: '内容',
                    dataIndex: 'name',
                    customRender:(v)=>{
                        return v.trim()||'暂无'
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: (v) => {
                        return (
                            <a-button-group>
                                <a-button
                                    type='danger'
                                    onClick={() => {
                                        this.changeConfig(v)
                                    }}>
                                    删除
                                </a-button>
                                <a-button
                                    type='primary'
                                    onClick={() => {
                                        this.id = v.id
                                        this.isShowJf = true
                                    }}>
                                    编辑
                                </a-button>

                            </a-button-group>
                        )
                    }
                }
            ],
            data: [],
            total: 0,
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            searchData: {
                username: '',
                status: undefined
            },
            levelArray: [],
            form: this.$form.createForm(this),
            confirmLoading: false,
            isShowJf: false,
            id: ''
        }
    },
    activated () {
        this.getList()
    },
    methods: {
        getList () {
            this.loading = true
            Order.OrderTuiList({
                page: this.current,
                num: this.pageSize,
            }).then(res => {
                this.data = res.result.map((value, key) => {
                    return { ...value, key, isEdit: false, pwd: '' }
                })
                this.loading = false
                this.total = parseInt(res.count)
            })
        },
        changePagination (pagination) {
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getList()
        },
        changeConfig (v) {
            this.$confirm({
                title: `删除`,
                content: `确定要删除此条吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        Order.DeleteOrderTui({
                            id:v.id
                        }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
        changeGroup (id, value) {
            let group_id = value || undefined
            this.$confirm({
                title: `修改用户组`,
                width: 350,
                content: (
                    <a-select placeholder="请选择用户组" style="width:100%;margin:20px 0px 10px 0px;padding-right:38px"
                              defaultValue={group_id} placeholder="请选用户组" onChange={(e) => {
                        group_id = e
                    }}>
                        {this.levelArray.map(v => {
                            return (<a-select-option value={v.id}>{v.title}</a-select-option>)
                        })}
                    </a-select>
                ),
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        Auth.changeJuese({ id, group_id }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
        addAdmin () {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = false
                    if (this.id) {
                        Order.SaveOrderTui({...values,id:this.id}).then(res => {
                            this.isShowJf = false
                            this.confirmLoading = false
                            this.getList()
                        }).catch(res => {
                            this.confirmLoading = false
                        })
                    } else {
                        Order.AddOrderTui(values).then(res => {
                            this.isShowJf = false
                            this.confirmLoading = false
                            this.getList()
                        }).catch(res => {
                            this.confirmLoading = false
                        })
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.inputGroup {
    > div {
        margin-bottom: 20px;
    }
}
</style>
